var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents-report-filters" },
    [
      _vm.open
        ? _c("c-button-2", {
            staticClass: "documents-report-filters__toggler",
            attrs: { label: "Скрыть фильтры" },
            on: {
              click: function ($event) {
                _vm.open = false
              },
            },
          })
        : _vm._e(),
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open",
              },
            ],
            staticClass: "documents-report-filters__slide",
          },
          [
            _vm.inited
              ? _c(
                  "div",
                  { staticClass: "documents-report-filters__wrapper" },
                  [
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__filial",
                      attrs: {
                        label: "Филиал",
                        type: "select",
                        "checkbox-value": _vm.form.filialsExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.filials,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.filialsExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.filials,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "filials", $$v)
                        },
                        expression: "form.filials",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__position",
                      attrs: {
                        label: "Должность",
                        type: "select",
                        "checkbox-value": _vm.form.positionsExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.positions,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.positionsExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.positions,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "positions", $$v)
                        },
                        expression: "form.positions",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__query",
                      attrs: {
                        label: "Имя или телефон",
                        placeholder: "Любые",
                        clearable: true,
                      },
                      on: {
                        enter: function ($event) {
                          return _vm.$emit("apply")
                        },
                      },
                      model: {
                        value: _vm.form.nameOrPhone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "nameOrPhone", $$v)
                        },
                        expression: "form.nameOrPhone",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__doc-type",
                      attrs: {
                        label: "Тип анализа",
                        type: "select",
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.analyseTypes,
                        "checkbox-value": _vm.form.analyseTypesExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.analyseTypesExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.analyseTypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "analyseTypes", $$v)
                        },
                        expression: "form.analyseTypes",
                      },
                    }),
                    _c("c-select", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__document",
                      attrs: {
                        type: "select",
                        label: "Наименование анализа",
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.analyses,
                        groups: _vm.collections.analyseTypes,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.analysesExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.analyses,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "analyses", $$v)
                        },
                        expression: "form.analyses",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__deadline",
                      attrs: {
                        type: "select",
                        label: "Срок годности анализа",
                        multiple: true,
                        placeholder: "Все",
                        items: _vm.collections.expirationTypes,
                      },
                      model: {
                        value: _vm.form.expirationTypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "expirationTypes", $$v)
                        },
                        expression: "form.expirationTypes",
                      },
                    }),
                    _c("c-range", {
                      staticClass:
                        "documents-report-filters__item range documents-report-filters__deadline-range",
                      attrs: {
                        max: 35,
                        min: 0,
                        label: "Истекает срок годности в течение, дн.",
                      },
                      model: {
                        value: _vm.form.expiresAfter,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "expiresAfter", $$v)
                        },
                        expression: "form.expiresAfter",
                      },
                    }),
                    _c("c-switcher", {
                      staticClass:
                        "documents-report-filters__item switcher documents-report-filters__problems",
                      attrs: { label: "Проблемы с анализами" },
                      model: {
                        value: _vm.form.withProblems,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "withProblems", $$v)
                        },
                        expression: "form.withProblems",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "documents-report-filters__item documents-report-filters__actions",
                      },
                      [
                        _c("c-button", {
                          staticClass: "documents-report-filters__reset",
                          attrs: { size: "large", label: "Сбросить" },
                          on: { click: _vm.reset },
                        }),
                        _c("c-button", {
                          staticClass: "documents-report-filters__apply",
                          attrs: {
                            label: "Применить",
                            color: "blue",
                            size: "large",
                          },
                          on: { click: _vm.apply },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
      _vm.open
        ? _c("c-button-2", {
            staticClass: "documents-report-filters__toggler",
            attrs: { label: "Скрыть фильтры" },
            on: {
              click: function ($event) {
                _vm.open = false
              },
            },
          })
        : _vm._e(),
      !_vm.open
        ? _c("c-button-2", {
            staticClass: "documents-report-filters__toggler",
            attrs: { label: "Показать фильтры" },
            on: {
              click: function ($event) {
                _vm.open = true
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }